import { Injectable } from "@angular/core";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  RoomStageLayoutFocusDeleteRequestDTO,
  RoomStageLayoutFocusSetRequestDTO,
  RoomStageLayoutFocusSetResponseDTO,
  RoomStageLayoutFocusSetResponseJson,
  RoomStageLayoutMainDeleteRequestDTO,
  RoomStageLayoutMainSetRequestDTO,
  RoomStageLayoutMainSetResponseDTO,
  RoomStageLayoutMainSetResponseJson,
  RoomStageLayoutUpdateRequestDTO
} from "../dto";

@Injectable()
export class RoomStageLayoutService {
  constructor(private readonly apiService: ApiService) {}

  roomStageLayoutFocusDelete(
    roomStageLayoutFocusDeleteRequestDTO: RoomStageLayoutFocusDeleteRequestDTO
  ): Observable<void> {
    const { roomId } = roomStageLayoutFocusDeleteRequestDTO.data;

    return this.apiService.delete<void>(`rooms/${roomId}/stage/layout/focus`);
  }

  roomStageLayoutFocusSet(
    roomStageLayoutFocusSetRequestDTO: RoomStageLayoutFocusSetRequestDTO
  ): Observable<void | RoomStageLayoutFocusSetResponseDTO> {
    const { roomId, streamId } = roomStageLayoutFocusSetRequestDTO.data;

    return this.apiService
      .post<Optional<RoomStageLayoutFocusSetResponseJson>>(
        `rooms/${roomId}/stage/layout/focus`,
        {
          streamId
        }
      )
      .pipe(
        map((_) => (_ ? new RoomStageLayoutFocusSetResponseDTO(_) : undefined))
      );
  }

  roomStageLayoutMainDelete(
    roomStageLayoutMainDeleteRequestDTO: RoomStageLayoutMainDeleteRequestDTO
  ): Observable<void> {
    const { roomId } = roomStageLayoutMainDeleteRequestDTO.data;

    return this.apiService.delete<void>(`rooms/${roomId}/stage/layout/main`);
  }

  roomStageLayoutMainSet(
    roomStageLayoutMainSetRequestDTO: RoomStageLayoutMainSetRequestDTO
  ): Observable<void | RoomStageLayoutMainSetResponseDTO> {
    const { roomId, streamId } = roomStageLayoutMainSetRequestDTO.data;

    return this.apiService
      .post<Optional<RoomStageLayoutMainSetResponseJson>>(
        `rooms/${roomId}/stage/layout/main`,
        {
          streamId
        }
      )
      .pipe(
        map((_) => (_ ? new RoomStageLayoutMainSetResponseDTO(_) : undefined))
      );
  }

  roomStageLayoutUpdate(
    roomStageLayoutUpdateRequestDTO: RoomStageLayoutUpdateRequestDTO
  ): Observable<void> {
    const { roomId, layout } = roomStageLayoutUpdateRequestDTO.data;

    return this.apiService.post<void>(`rooms/${roomId}/stage/layout`, {
      layout
    });
  }
}
